/**
 * 数值格式化工具
 * 用于处理数值的显示和输入格式化
 */

/**
 * 格式化数值为两位小数（显示用）
 * @param {number|string} value - 要格式化的值
 * @returns {string} 格式化后的两位小数字符串
 */
export function formatToTwoDecimals(value) {
  if (value === undefined || value === null || value === '') {
    return '0.00';
  }

  const numericValue = parseFloat(value);
  if (isNaN(numericValue)) {
    return '0.00';
  }

  return numericValue.toFixed(2);
}


/**
 * 获取嵌套对象的值
 * @param {Object} obj - 对象
 * @param {string} path - 属性路径
 * @returns {*} 属性值
 */
export function getNestedValue(obj, path) {
  return path.split('.').reduce((current, key) => {
    return current ? current[key] : undefined;
  }, obj);
}

export function fixed2(val) {
    return val.toFixed(2);
}